module.exports = __webpack_public_path__ + "static/media/txzhifubao@2x.a27ce406.png";